(function() {
    var s=document.createElement('script');
    s.async=true;s.className='demoup_stage1_script';
    s.src='//static.demoup.com/api/stages/657/stage1.js?url='+encodeURI(document.URL);
    var m=document.getElementsByTagName('head')[0];m.parentNode.insertBefore(s, m);
    }
)();